module.exports = __webpack_public_path__ + "static/media/1b.acba70c0.jpg";